export default {
      id: "icon-nav-up-usage",
      viewBox: "0 0 56 56",
      url: __webpack_public_path__ + "img/icons.c2f64a3b.svg#icon-nav-up",
      toString: function () {
        return this.url;
      }
    }